import { createContext } from "react";

const AppContext = createContext('app');

export {
  AppContext
};
